import {combineReducers} from "redux";
import listReducer, * as listSelectors from './listReducer';
import {translate} from '@elements/translations';

export default combineReducers({
    list: listReducer
});

export const getListFetchingState = (state) => listSelectors.getFetchingState(state.list);
export const getListItems = (state) => listSelectors.getItems(state.list);
export const getDeclineReasons = (state) => listSelectors.getDeclineReasons(state.list);
